import angular from 'angular';
import config from './control.config';

import {ControlRealizations} from './realizations/control-realizations.component';
import {ControlWorkedHours} from './workedHours/control-worked-hours.component';

import ControlController from './control.controller';

import './control.scss';

/**
 * @desc Control Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.control', [])
  .component('controlRealizationsComponent', ControlRealizations)
  .component('controlWorkedHoursComponent', ControlWorkedHours)
  .controller('ControlController', ControlController)
  .config(config)
  .name;
